import React from 'react';
import { PurchaseOrder, PurchaseOrderHistoryEntry } from '../../types/purchaseOrder';
import { formatDate } from '../../utils';
import CommentsSection from '../CommentsSection';

interface PurchaseOrderHistoryProps {
  purchaseOrder: PurchaseOrder;
  onAddComment: (comment: string) => Promise<void>;
}

const PurchaseOrderHistory: React.FC<PurchaseOrderHistoryProps> = ({
  purchaseOrder,
  onAddComment
}) => {
  // Get all history entries including handling unit history
  const getAllHistoryEntries = (): PurchaseOrderHistoryEntry[] => {
    const allEntries: PurchaseOrderHistoryEntry[] = [...(purchaseOrder.history || [])];

    // Add handling unit history entries
    purchaseOrder.items.forEach(item => {
      item.handlingUnits.forEach(hu => {
        if (hu.history) {
          const huEntries = hu.history.map(entry => ({
            ...entry,
            details: `[HU ${hu.huNumber}] ${entry.details}`
          }));
          allEntries.push(...huEntries);
        }
      });
    });

    // Sort by timestamp, most recent first
    return allEntries.sort((a, b) => {
      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);
      return dateB.getTime() - dateA.getTime();
    });
  };

  return (
    <div className="grid">
      <div className="col-12">
        <h4>Notes</h4>
        <p>{purchaseOrder.notes || 'No notes available.'}</p>
      </div>
      <div className="col-12">
        <CommentsSection 
          comments={getAllHistoryEntries()} 
          onAddComment={onAddComment} 
        />
      </div>
    </div>
  );
};

export default PurchaseOrderHistory;
